import { Space } from '@sravni/react-design-system';
import type React from 'react';

import { CommonFDSkeleton } from 'entities/scenario';

export const ScenarioSkeleton = () => {
  return (
    <Space className="h-mt-32 h-mb-32">
      <CommonFDSkeleton />
    </Space>
  );
};
